import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const EyeIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 20 20" // The viewbox here is important as it won't display properly without this specific value
    >
      <path
        d="M2.5 10.8333C5.5 4.16659 14.5 4.16659 17.5 10.8333"
        stroke={props.stroke || '#3F1D75'}
        fill={'none'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.1667C8.61925 14.1667 7.5 13.0475 7.5 11.6667C7.5 10.286 8.61925 9.16675 10 9.16675C11.3807 9.16675 12.5 10.286 12.5 11.6667C12.5 13.0475 11.3807 14.1667 10 14.1667Z"
        stroke={props.stroke || '#3F1D75'}
        fill={'none'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
